import React, { useId } from 'react';

/**
 * Campo de formulário com label associado por id.
 *
 * Todo o app usava `<label>Texto</label><input/>` como irmãos, sem htmlFor —
 * o que faz o leitor de tela anunciar o campo sem nome e impede que tocar no
 * rótulo foque o campo (relevante no celular, onde o alvo é pequeno).
 *
 * @param label   texto do rótulo
 * @param hint    ajuda curta abaixo do campo
 * @param erro    mensagem de validação
 * @param largura 'cheia' ocupa a linha toda; por padrão divide o espaço
 */
export default function Field({ label, hint, erro, largura, children, obrigatorio }) {
  const id = useId();
  const descId = hint || erro ? `${id}-desc` : undefined;

  return (
    <div className={`field ${largura === 'cheia' ? 'field--cheia' : ''}`}>
      {label && (
        <label htmlFor={id}>
          {label}
          {obrigatorio && <span className="field-obrigatorio" aria-hidden="true"> *</span>}
        </label>
      )}
      {/* Injeta id e aria-describedby no controle, sem que cada tela precise saber. */}
      {React.isValidElement(children)
        ? React.cloneElement(children, {
            id: children.props.id || id,
            'aria-describedby': children.props['aria-describedby'] || descId,
            'aria-invalid': erro ? true : children.props['aria-invalid'],
          })
        : children}
      {(hint || erro) && (
        <div id={descId} className={`field-hint ${erro ? 'field-hint--erro' : ''}`}>
          {erro || hint}
        </div>
      )}
    </div>
  );
}

/** Linha de campos que quebra em uma coluna no celular. */
export function FormRow({ children, min }) {
  return (
    <div className="form-row" style={min ? { '--field-min': `${min}px` } : undefined}>
      {children}
    </div>
  );
}
